import { Fragment } from 'react'
import { Box, Stack, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const useColumnCount = columns => {
  const theme = useTheme()
  const matches = {
    xs: true,
    sm: useMediaQuery(theme.breakpoints.up('sm')),
    md: useMediaQuery(theme.breakpoints.up('md')),
    lg: useMediaQuery(theme.breakpoints.up('lg')),
    xl: useMediaQuery(theme.breakpoints.up('xl')),
  }
  const key = ['xl', 'lg', 'md', 'sm', 'xs'].find(name => matches[name] && columns[name] != null)
  return Math.max(columns[key] ?? 1, 1)
}

const toBlocks = (items, isFullWidth) =>
  items.reduce((blocks, item) => {
    const last = blocks[blocks.length - 1]
    if (isFullWidth(item)) blocks.push({ full: item })
    else if (last?.items) last.items.push(item)
    else blocks.push({ items: [item] })
    return blocks
  }, [])

export default function ColumnMasonry({
  items,
  getKey,
  renderItem,
  isFullWidth = () => false,
  columns = { xs: 1 },
  spacing = 1,
}) {
  const count = useColumnCount(columns)

  return (
    <Stack spacing={spacing}>
      {toBlocks(items, isFullWidth).map((block, index) =>
        block.full ? (
          <Fragment key={getKey(block.full)}>{renderItem(block.full)}</Fragment>
        ) : (
          <Box key={`block-${index}`} sx={{ display: 'flex', alignItems: 'flex-start', gap: spacing }}>
            {Array.from({ length: count }, (_, column) => (
              <Stack key={column} spacing={spacing} sx={{ flex: 1, minWidth: 0 }}>
                {block.items
                  .filter((_, position) => position % count === column)
                  .map(item => (
                    <Fragment key={getKey(item)}>{renderItem(item)}</Fragment>
                  ))}
              </Stack>
            ))}
          </Box>
        ),
      )}
    </Stack>
  )
}
